
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue, CASign } from "@newview/base-web";
import { } from "@newview/ui";
import { UserinforApi } from "@newview/netsysconfig-api";
// import {CASign} from "@newview/tools"
@Component({
  name: "", 
  components: {
  },
})
export default class CASignView extends BaseVue {
  @Prop({ default: 0 }) index!: any;    //唯一标识
  @Prop({ default: false }) isSign1!: any;    //是否显示签字按钮
  @Prop({ default: false }) isSign2!: any;    //是否显示签章按钮
  @Prop({ default: false }) isSign3!: any;    //是否显示驳回按钮
  @Prop({ default: "" }) sealContent1!: any;    //签字内容
  @Prop({ default: "" }) sealContent2!: any;    //签章内容
  @Prop({ default: "" }) sealResult1!: any;    //签字结果
  @Prop({ default: "" }) sealResult2!: any;    //签章结果
  userinforApi:UserinforApi=new UserinforApi();
  caSign=new CASign()
  sealMgr:any=null
  base64Img1=""
  base64Img2=""
  btnLoading1=false
  btnLoading2=false
  cancelsign:boolean=true;
  @Watch("sealResult1")
  sealResult1Change(){
    console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxx")
    if(!this.isNull(this.sealResult1)){
      
      if(this.sealResult1<0){
        return
      }
      this.isSignObj.isSign1 = false
      this.Verify(this.sealContent1,this.sealResult1,1)
    }else{
      this.base64Img1="";
      if(this.isSign1){
        this.isSignObj.isSign1 = true
      }
    } 
  }
  
  @Watch("sealResult2")
  sealResult2Change(){
    if(!this.isNull(this.sealResult2)){
      this.Verify(this.sealContent2,this.sealResult2,2)
    } 
  }
  isSignObj = {
    isSign1:false,
    isSign2:false
  }
  mounted() {
    this.isSignObj = {
      isSign1:this.isSign1,
      isSign2:this.isSign2
    }
    if(!this.isNull(this.sealResult1)){
      this.Verify(this.sealContent1,this.sealResult1,1)
    }    
    if(!this.isNull(this.sealResult2)){
      this.Verify(this.sealContent2,this.sealResult2,2) 
    }    
  }
  // sign(type){
  //   this.prompt(" ","请输入证书密钥",(res)=>{
  //     this.DoSeal(this["sealContent"+type],res,type)
  //   })  
  //   this.DoSeal(type)  
  // }
  /**
   * @description: 签字/签章操作
   * @param {*} content  签字内容
   * @param {*} sealunique 印章密钥
   * @param {*} certunique 证书密钥
   * @param {*} password 签字密码
   * @return {*}
   * @author: pangting
   */  
  async DoSeal(type){
    this["btnLoading"+type] = true
    try {
        this.cancelsign=true;
        this.$emit("do-seal-before") ;
        let res = await this.caSign.DoSeal(type,this["sealContent"+type])
        if(res){  
          //this.success((type==1?"签字":"盖章")+"成功")
          this.$emit("sign-success",{result:res,type:type,index:this.index})
        } 
      this["btnLoading"+type] = false
      this.$emit("do-seal-after")    
    } catch (e) {
      this.error(e.message);
      this["btnLoading"+type] = false
    }
  }
  /**撤销签字 */
  clearSeal(){
       this.base64Img1='';
       this.base64Img2='';
       this.btnLoading1=false;
       this.btnLoading2=false;
       if(this.isSign1){
        this.isSignObj.isSign1 = true
       }
       if(this.isSign2){
        this.isSignObj.isSign2 = true
       }
       this.cancelsign=false; 
  }
  /**
   * 驳回审批、退回审批 add by msh 20210902
   */
  ReBack(){
    this.$emit("sign-reback");
  }
  /**
   * @description: 验章
   * @param {*} sealContent 签字内容
   * @param {*} sealResult 签字结果
   * @param {*} type  1:签字 2：签章
   * @return {*}
   * @author: pangting
   */  
  async Verify(sealContent, sealResult,type){
    if(this.cancelsign){
        let res:any = await this.caSign.VerifySealWithResult(sealContent, sealResult)   
        if(!this.isNull(res.sealImg)){
          this["base64Img"+type] = "data:image/png;base64,"+res.sealImg;  
          this.$emit("on-verify",res)
        }
    }   
  }
}
